interface TextPanelProps {
  [key: string]: any;
}


export default function TextPanel(props: TextPanelProps) {
    return (
        <>
        <div className="l-node-frontpage__block-small extra">
            <div className="block-inner">
                <div className="fr-view" dangerouslySetInnerHTML={{ __html: props['free-text-right-froala'] || '' }} />
            </div>
        </div>
        </>
    );
}